import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
export const receipt = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: receipt.url(args, options),
    method: 'get',
})

receipt.definition = {
    methods: ["get","head"],
    url: '/app/member/contributions/{contribution}/receipt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
receipt.url = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contribution: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { contribution: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            contribution: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contribution: typeof args.contribution === 'object'
        ? args.contribution.uuid
        : args.contribution,
    }

    return receipt.definition.url
            .replace('{contribution}', parsedArgs.contribution.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
receipt.get = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
receipt.head = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: receipt.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
const receiptForm = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
receiptForm.get = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Member\PaymentReceiptController::receipt
* @see app/Http/Controllers/Member/PaymentReceiptController.php:46
* @route '/app/member/contributions/{contribution}/receipt'
*/
receiptForm.head = (args: { contribution: string | { uuid: string } } | [contribution: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: receipt.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

receipt.form = receiptForm

const contributions = {
    receipt: Object.assign(receipt, receipt),
}

export default contributions